export default __webpack_public_path__ + "static/media/logo1.4b0afe77.png";